import { useAppContext } from '@contexts/app/hooks/useAppContext';

export const useIsMobileApp = () => {
    const { appId } = useAppContext();

    return appId == 'androidAgoda' || appId === 'iosAgoda';
};
